import MuiAvatar, { AvatarProps as Props } from '@material-ui/core/Avatar'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import AvatarIcon from '../../stories/assets/avatar-icon.svg'

export type AvatarProps = {
  customSize?: 'small' | 'medium' | 'large' | 'xl'
  imageAvatar?: boolean
} & Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconAvatar: {
      background: theme.palette.primary.main,
      ...theme.typography.overline
    },
    imgAvatar: {
      background: theme.palette.grey[400]
    },
    small: {
      width: 24,
      height: 24,
      ...theme.typography.caption
    },
    medium: {
      width: 32,
      height: 32
    },
    large: {
      width: 40,
      height: 40
    },
    xl: {
      width: 128,
      height: 128
    }
  })
)

const Avatar: React.FC<AvatarProps> = (props) => {
  const classes = useStyles()
  const { imageAvatar, customSize, children, ...rest } = props
  const getSize = (size: string) => {
    if (size === customSize) {
      return { root: classes[size] }
    }
  }
  const avatar = () => {
    if (imageAvatar) {
      return rest.src ? rest.src : AvatarIcon
    } else {
      return ''
    }
  }
  return (
    <MuiAvatar
      classes={getSize(customSize as string)}
      className={imageAvatar ? classes.imgAvatar : classes.iconAvatar}
      src={avatar()}
      {...rest}
    >
      {children}
    </MuiAvatar>
  )
}

export default Avatar
